module.exports = __webpack_public_path__ + "static/media/3.3819c6ca.jpg";